import { DatePipe } from '@angular/common';
import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, OnDestroy, NgModule } from '@angular/core';
import {
    NavController,
    ViewController,
    Content,
    NavParams,
    AlertController,
    ToastController,
    App,
    LoadingController,
    Events,
    IonicModule,
} from 'ionic-angular';

import { mmcFace } from '../../+lotteryFace/mmc';
import { mbFace } from '../../+lotteryFace/mb';
import { mbdbFace } from '../../+lotteryFace/mbdb';

import {
    LotteryMathZXFSComponent,
    LotteryMathZH1Component,
    LotteryMathZH2Component,
    LotteryMathZXZHComponent,
    LotteryMathDSComponent,
    LotteryMathDWDComponent,
    LotteryMathHZComponent,
    LotteryMathDXTXComponent,
    LotteryMathBDComponent,
    LotteryMathRZXComponent,
    LotteryMathLTZXHComponent,
    LotteryMathSMComponent,
    LotteryMathDTComponent,
} from '../../component/+lotteryMath';
import { AppConfigService } from '../../services/appConfig.service';
import { LotteryService } from '../../services/lottery.services';
import { AppDialog } from '../../component/appDialog';
import { TextSelectComponent } from '../../component/+lotteryMath/textSelect';
import { RecordListPage } from '../recordList/recordList';
import { p3p5Face } from '../../+lotteryFace/p3p5';
import { threeDFace } from '../../+lotteryFace/threeDFace';
import { s11x5Face } from '../../+lotteryFace/s11x5';
import { sixmarkFace } from '../../+lotteryFace/sixmark';
import { jx11x5Face } from '../../+lotteryFace/jx11x5';
import { gd11x5Face } from '../../+lotteryFace/gd11x5';
import { tjsscFace } from '../../+lotteryFace/tjssc';
import { xjsscFace } from '../../+lotteryFace/xjssc';
import { pk10Face } from '../../+lotteryFace/pk10';

import { HelperPage } from '../../component/helper/helper';
import { OpenNumComponent } from '../../component/openNum/openNum';
import { diceFace } from '../../+lotteryFace/dice';
import { SixMarkService } from '../../services/sixmark.services';

import { CommonService } from '../../services/common.service';
import { mega645Face } from '../../+lotteryFace/vietlott';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';
import { LoginPage } from '../login/login';
import { TranslateService } from 'ng2-translate';

// import {DecimalPipe} from "@angular/common";

@Component({
    templateUrl: 'lottery.html',
    selector: 'lottery-page',
    providers: [DatePipe],
})
export class LotteryPage implements OnInit, AfterViewInit, OnDestroy {
    _IMG_FOLDER_LOTTERY_PATH: string = 'build/assets/images/lottery';
    @ViewChild(LotteryMathSMComponent) lotteryMathSM: LotteryMathSMComponent;
    @ViewChild(Content) content: Content;
    @ViewChild('lotteryArea') selectAreaView: any;
    // betInfo with bet api formate
    private betInfoSM: any = [];
    // list of history
    private betHistory;
    //彩种id
    static lotteryId: number;
    //真实可用余额
    balance: number;
    enableBalance: any;
    //投注金额
    static betMoney: number = 0;
    static betTraceTime: number = 0;
    private pageDom: HTMLElement;
    //游戏名称
    private gameName: string;
    private gameNameTitle: string;
    //游戏统称类型
    private lotteryType: string;
    private gameId: number;
    //游戏配置face文件
    private lotteryFaces: any;
    //玩法彩种对象
    private activeLottery: any;
    //title标题
    private planeTitle: string;
    //下拉板是否显示
    private dropPanelHidden: boolean = true;
    private openRecordPanelShow: boolean = false;
    // 弹出框
    private openHelper: boolean = false;
    //游戏玩法类型
    private lotterySelectType;
    //选择区排列
    private selectAreaOption;
    //玩法id
    private methodId: number;
    //玩法id
    private methodIdInDB: string;
    //总注数
    private totalNumber: number = 0;
    //总金额
    private totalMoney: number = 0;
    //投注倍数
    private betTimes: number = 1;
    //模式
    private modes: any = [];
    private modeVal: any = 0;
    //返点
    private dyprize: any = [];
    public dyprizeFe: string = '';
    private dyprizeVal: number;
    private dyprizeHide: boolean = false;
    //投注方式
    private betType: string;
    //投注号码
    private selectNo: any;
    //直选复式投注号码
    private selectNoText: any = [];
    //任选位置参数
    private defaultPosition: any = [];
    private noShowStr: string;
    //投注提交参数
    private betPost: any;
    //对话框弹出消息配置参数
    private betDialogParams: any;

    //开奖记录
    private winOpenNumberList: any = [];
    //系统倒计时
    private countTime: string = '';
    //当前期号
    private issue: string;
    //倒计时定时器
    static countTimer: any;
    //是否是秒秒彩
    private isMMC: boolean;
    private isMBDB: boolean;
    // Is Six Mark or Three Dices game

    private lotteryName: string;

    showPageResult = false;

    static isSMorTD: boolean;
    static isTaiXiuGame: boolean;

    get staticIsSMorTD() {
        return LotteryPage.isSMorTD;
    }

    // Indicates the visibility of popup - use with isPopupTriggered
    private isSMTDPopupHidden: boolean = true;
    // Set this to true to show popup
    private isPopupTriggered: boolean = false;
    /**
     * 追号期数
     * @type {{isGo: boolean}}
     */
    private goIssues: any = {
        isGo: false,
    };
    //开奖号码
    winNumber: any = {
        nums: [],
        issue: '',
    };
    //需要开奖的玩法
    openLotteryName: any = ['CSSSC', 'Jz45', 'PHP', 'SSCBF', 'CqSSC'];
    private lotteryFn = {
        MMC: () => (this.lotteryFaces = mmcFace(this.translate)), // 1 giay
        Jz45: () => (this.lotteryFaces = mmcFace(this.translate)), // 45 giay
        CSSSC: () => (this.lotteryFaces = mmcFace(this.translate)), // 1 phut
        PHP: () => (this.lotteryFaces = mmcFace(this.translate)), // 1.5 phut
        SSCBF: () => (this.lotteryFaces = mmcFace(this.translate)), // 2 phut
        CqSSC: () => (this.lotteryFaces = mmcFace(this.translate)), // 5 phut
        VN: () => (this.lotteryFaces = mmcFace(this.translate)), // mien nam, mien trung
        MB: () => (this.lotteryFaces = mbFace(this.translate)), // mien bac
        MBDB: () => (this.lotteryFaces = mbdbFace(this.translate)), // mien bac dac biet
        //'mega645': () => this.lotteryFaces = mega645Face, // mega 6/45
    };

    static clickAudio: any;
    public userPrizeCurrent: any;
    private payPrizeNum: number;
    private coutTimeResult: string = '00:00:00';
    private coutTimeoutResult: any;
    private toggleHTimeResult: boolean = true;
    private totalNumWin: number;

    // Flag to display layout fast select, based on value of Array layoutFastSelect of selectArea inside currently activeLottery
    private showLayoutFastSelect: boolean = true;

    // arrMMCGameID = [50, 100, 101, 102, 103, 104, 400, 401, 402];
    arrMMCGameID = [100, 101, 102, 103, 104, 80, 91, 93, 300, 301, 302, 303, 304, 305, 400, 401, 402];
    arrXSNhanh = [50, 100, 101, 102, 103, 104];
    isXoSoNhanh: boolean = false;
    selectTypeGame: string = 'typeChonSo';
    flagTypeGameDauDuoi: boolean = true;
    flagTypeGameDeTopBot: boolean = true;
    flagTypeGameLoXien: boolean = true;
    classBderLastSegment: boolean = false;
    classBderFirstSegment: boolean = false;
    private timerLoadBalance: any;

    private arrTempSaveDualNum: any = [];

    titleKqxs: string = 'Xem ngay';
    dotLoadingKqxs = 3;

    options: InAppBrowserOptions = {
        location: 'yes', //Or 'no'
        hidden: 'no', //Or  'yes'
        clearcache: 'yes',
        clearsessioncache: 'yes',
        zoom: 'yes', //Android only ,shows browser zoom controls
        hardwareback: 'yes',
        mediaPlaybackRequiresUserAction: 'no',
        shouldPauseOnSuspend: 'no', //Android only
        closebuttoncaption: 'Close', //iOS only
        disallowoverscroll: 'no', //iOS only
        toolbar: 'yes', //iOS only
        enableViewportScale: 'no', //iOS only
        allowInlineMediaPlayback: 'no', //iOS only
        presentationstyle: 'pagesheet', //iOS only
        fullscreen: 'yes', //Windows only
    };

    constructor(
        private app: App,
        public events: Events,
        public navParams: NavParams,
        el: ElementRef,
        private alertCtrl: AlertController,
        private toastCtrl: ToastController,
        public loadingCtrl: LoadingController,
        private  translate: TranslateService,
        public navCtrl: NavController,
        public viewCtrl: ViewController,
        private lotteryService: LotteryService,
        private sixMarkService: SixMarkService,
        private common: CommonService,
        private datePIPE: DatePipe,
        private theInAppBrowser: InAppBrowser
    ) {
        this.pageDom = el.nativeElement;
        this.lotteryType = navParams.data['lotteryName'];
        this.gameId = navParams.data['lotteryId'];
        this.gameName = navParams.data['title'];
        console.log('====================================');
        console.log('navParams',navParams);
        console.log('====================================');
        this.gameNameTitle = navParams.data['titleGame'];
        this.isMMC = this.lotteryType == 'MMC';
        this.isMBDB = this.lotteryType == 'MBDB';
        LotteryPage.isSMorTD = this.lotteryType == 'liuhe' || this.lotteryType == 'fenfenliuhe';
        //this.loadingAudio();

        this.lotteryFn[this.lotteryType]();

        this.showPageResult = this.arrXSNhanh.indexOf(Number(this.gameId)) > -1;

        this.checkMMCGame(Number(this.gameId));
    }

    ngOnInit() {
        this.bindEvent();
    }

    loadingAudio() {
        LotteryPage.clickAudio = new Audio();
        LotteryPage.clickAudio.src = 'build/assets/images/audio/click.mp3';
        LotteryPage.clickAudio.load();
    }

    static clickPlay() { }

    bindEvent() {
        this.lotteryService.getBalance((data) => {
            this.balance = data['balance'];
        });
        this.events.subscribe('issues:go', (userEventData) => {
            this.goIssues = userEventData;
            if (this.goIssues.totalMoney > this.balance) {
                if (this.totalMoney > this.balance) {
                    AppDialog.toast({
                        toastCtrl: this.toastCtrl,
                        message: 'Số dư hiện tại không đủ. Nạp thêm tiền để tiếp tục',
                    });
                }
            }
        });
    }

    /**
     * 改变时间和切换时间
     * @param opentime
     * @param nowtime
     * @param issue
     */
    openRecordAndChangeTime(seleend, nowtime, opentime, issue) {
        let newIssue = this.issue;
        this.issue = issue;
        this.setOpenTime(seleend, nowtime, opentime);

        if (this.issue != newIssue) {
            this.events.publish('issues:change');
            /**
             * 是否抓取开奖结果
             */
            if (this.openLotteryName.indexOf(this.lotteryType) > -1) {
                this.getOpenRecord(newIssue, 0);
            }
        }
    }

    onLotteryAfter(initParams: any) {
        this.lotteryName = initParams['lotteryName'];
        LotteryPage.lotteryId = initParams['lotteryid'];
        this.issue = initParams['issue'];
        this.setOpenTime(
            initParams['endtime'],
            initParams['servertime'],
            initParams['opentime'],
            initParams['hisopentime'],
            initParams['hisendtime']
        );
    }

    /**
     * 设置开奖时间,如果是秒秒彩就退出
     * @param opentime
     * @param servertime
     */
    setOpenTime(endtime: string, servertime: string, opentime: string, hisopentime?: string, hisendtime?: string) {
        if (this.isMMC) {
            return;
        }

        //set title kqxs
        if (hisopentime && hisendtime) {
            if (
                +new Date(servertime.replace(/-/g, '/')) >= +new Date(hisendtime.replace(/-/g, '/')) &&
                +new Date(servertime.replace(/-/g, '/')) <= +new Date(hisopentime.replace(/-/g, '/'))
            ) {
                this.titleKqxs = this.translate.instant('DANG_MO_THUONG');
            }
        }

        let pourTime: number = (+new Date(endtime.replace(/-/g, '/')) - +new Date(servertime.replace(/-/g, '/'))) / 1000;

        clearInterval(LotteryPage.countTimer);
        LotteryPage.countTimer = setInterval(() => {
            pourTime--;
            if (pourTime >= 0) {
                let hour: any = parseInt((pourTime / 3600).toString());
                let minute: any = parseInt(((pourTime - hour * 3600) / 60).toString());
                let second: any = parseInt((pourTime % 60).toString());
                if (hour < 10) {
                    hour = '0' + hour;
                }
                if (minute < 10) {
                    minute = '0' + minute;
                }
                if (second < 10) {
                    second = '0' + second;
                }
                this.countTime = hour + ':' + minute + ':' + second;
                this.dotLoadingKqxs--;
                if (this.dotLoadingKqxs < 1) this.dotLoadingKqxs = 3;
            }
            if (pourTime === -1) {
                this.toggleHTimeResult = false;
                this.timerShowResult(opentime, endtime, () => {
                    this.toggleHTimeResult = true;
                    // make sure get timer for next issue "lan 2"
                    this.readCurrIssue();
                });
                //如果开奖结果打开获取开奖历史
                if (this.openRecordPanelShow) {
                    if (LotteryPage.isSMorTD) {
                        this.getWinOpenNumberSM();
                    } else {
                        this.getWinOpenNumber();
                    }
                }

                // make sure get timer for next issue "lan 1"
                setTimeout(() => {
                    this.readCurrIssue();
                }, 1);

                //清空定时器重新请求初始数据
                clearInterval(LotteryPage.countTimer);
                //刷新各个面板
            }
        }, 1000);
    }

    /**
     * 读取当前期号
     */
    readCurrIssue() {
        if (this.isMMC) {
            return;
        }
        let dataParams = {
            lotteryid: LotteryPage.lotteryId,
        };
        this.lotteryService.lotteryCurrentIssue(dataParams, this.alertCtrl).then((data) => {
            this.openRecordAndChangeTime(data['saleend'], data['nowtime'], data['opentime'], data['issue']);
        });
    }

    /**
     * getWinOpenNumberSM()
     * get win open number of sixmark and dice
     */
    getWinOpenNumberSM() {
        let dataParams = {
            lotteryid: LotteryPage.lotteryId,
            num: 10,
        };
        this.sixMarkService.lotteryWinOpenNumber(dataParams, this.alertCtrl).then((response) => {
            if ((response['status'] = 'success')) {
                response['data'].map((item) => {
                    return item['winnumber'];
                });
                this.winOpenNumberList = response['data'];
                console.log('this.winOpenNumberList', this.winOpenNumberList);

            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: response['status'],
                });
            }
        });
    }

    /**
     * 得到开奖历史号码
     */
    getWinOpenNumber() {
        //判断是否是秒秒彩
        if (this.isMMC) {
            let dataParams = {
                lotteryid: LotteryPage.lotteryId,
                num: 6,
            };
            this.lotteryService.lotteryMMCWinOpenNumber(dataParams, this.alertCtrl).then((data) => {
                if (!data['msg']) {
                    data['winnumberlist'].map((item) => {
                        return item['winnumber'];
                    });
                    if (data['winnumberlist'][0].winnumber === '') {
                        return;
                    }
                    this.winOpenNumberList = data['winnumberlist'];
                } else {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: data['msg'],
                    });
                }
            });
        } else {
            let dataParams = {
                id: LotteryPage.lotteryId,
                num: 10,
            };
            this.lotteryService.lotteryWinOpenNumber(dataParams, this.alertCtrl).then((data) => {
                if (!data['msg']) {
                    data['reslist'].map((item) => {
                        return item['winnumber'];
                    });
                    this.winOpenNumberList = data['reslist'];
                } else {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: data['msg'],
                    });
                }
            });
        }

        console.log(' this.winOpenNumberList', this.winOpenNumberList);

    }

    ionViewWillEnter() {
        // console.log(this.pageDom.getElementsByTagName('ion-header')[0].getBoundingClientRect().height);
    }

    //选择游戏类型
    selectActiveLottery(activeLottery: any) {
        console.log('activeLottery lottery', activeLottery);

        let objCustom = {
            guideTxt: '',
            methoddesc: '',
            methodexample: '',
            userPrizeCurrent: '',
        };
        objCustom.guideTxt = activeLottery['activeLottery'].guideTxt;
        objCustom.methoddesc = activeLottery['activeLottery'].methoddesc;
        objCustom.methodexample = activeLottery['activeLottery'].methodexample;
        objCustom.userPrizeCurrent = activeLottery['userPrizeCurrent']
        this.activeLottery = activeLottery.activeLottery;
        this.planeTitle = activeLottery.title;

        activeLottery.activeLottery['selectArea'].objCustom = objCustom;

        this.selectAreaOption = activeLottery.activeLottery['selectArea'];
        this.lotterySelectType = activeLottery.activeLottery['selectType'];

        this.noShowStr = activeLottery.activeLottery['show_str'];

        if (activeLottery.activeLottery['dyprize']) {
            let dyprizeAr = activeLottery.activeLottery['dyprize'];
            this.methodId = activeLottery.activeLottery['methodid'];
            this.methodIdInDB = activeLottery.activeLottery['methodidInDB'];

            // use interface as const without business related id of database
            this.showLayoutFastSelect = activeLottery['activeLottery'].selectArea.layoutfastslect.length > 0;

            this.flagTypeGameDauDuoi = true;
            this.flagTypeGameLoXien = true;
            this.classBderLastSegment = false;
            if ([9, 10, 20, 22].filter((x) => x === Number(this.methodId)).length > 0) {
                // methodid of 'dau-duoi'
                this.flagTypeGameDauDuoi = false;
                this.selectTypeGame = 'typeChonSo';
            } else if (
                [3, 4, 5, 16, 17, 18].filter((x) => x === Number(this.methodId)).length > 0 ||
                [27, 28, 29, 30, 31, 32].filter((x) => x === Number(this.methodId)).length > 0
            ) {
                // xien, lo truot
                this.flagTypeGameLoXien = false;
                this.selectTypeGame = 'typeNhapSo';
                this.classBderFirstSegment = true;
            } else if ([25, 26, 23, 24].filter((x) => x === Number(this.methodId)).length > 0) {
                // lo 4 so
                this.selectTypeGame = 'typeChonSo';
                this.classBderLastSegment = true;

                // tyep detopbot
            } else if ([200, 216, 224, 227, 231, 233, 241].filter((x) => x === Number(this.methodId)).length > 0) {
                this.selectTypeGame = 'typeTopBot';
                this.flagTypeGameDauDuoi = false;
                this.classBderLastSegment = false;
            } else {
                this.selectTypeGame = 'typeChonSo';
                this.classBderLastSegment = true;
            }

            // old
            this.dyprize = dyprizeAr[0]['prize'][0];
            this.dyprize['prize'] = Number(
                parseFloat(this.dyprize['prize']) % 1 != 0 ? this.dyprize['prize'] : parseFloat(this.dyprize['prize']).toFixed(0)
            );
            this.dyprize['point'] = Math.ceil(this.dyprize['point'] * 1000) / 10;
            this.dyprizeFe = (LoginPage.cytype != 1) ? this.dyprize.prize * 1000 : this.dyprize.prize;
            this.payPrizeNum = Number(activeLottery.activeLottery['payprizenum']);

            //   this.modeVal = 0;
            this.totalMoney = 0;
            this.totalNumber = 0;
            if (dyprizeAr.length > 1) {
                this.dyprizeHide = true;
                this.dyprizeVal = null;
            } else {
                this.dyprizeHide = false;
                this.dyprizeVal = 0;
            }
        }

    }


    selectActiveLottery2(DatActiveGame: any) {
        const activeGame = DatActiveGame.activeGame;
        // console.log('activeGame',activeGame);

        this.dyprize = activeGame.dyprize[0].prize[0];
        // this.dyprize['prize'] = Number(
        //     parseFloat(this.dyprize['prize']) % 1 != 0 ? this.dyprize['prize'] : parseFloat(this.dyprize['prize']).toFixed(0)
        // );
        // this.dyprize['prize'] = activeGame.dyprize[0].prize[0].prize;
        // this.dyprize['point'] = Math.ceil(activeGame.dyprize[0].prize[0].point * 1000) / 10;
        this.dyprizeFe = activeGame.dyprize[0].prize[0].prizeFe;
        this.payPrizeNum = Number(activeGame.payprizenum);
        this.methodIdInDB = activeGame.methodidInDB
        // this.selectNo[0].codePlay = activeGame.codePlay;
        this.modeVal = 0;
        this.totalMoney = 0;
        this.totalNumber = 0;
        // if (dyprizeAr.length > 1) {
        //     this.dyprizeHide = true;
        //     this.dyprizeVal = null;
        // } else {
        //     this.dyprizeHide = false;
        //     this.dyprizeVal = 0;
        // }
        // }

    }

    //切换下拉游戏选择面板
    toggleGamePanel() {
        this.dropPanelHidden = !this.dropPanelHidden;
        // let taBarDom: HTMLElement = this.navCtrl.parent.elementRef.nativeElement.querySelector('ion-tabbar');
        let taBarDom: HTMLElement = this.navCtrl.parent._elementRef.nativeElement.querySelector('div.tabbar');
        if (!this.dropPanelHidden) {
            taBarDom.setAttribute('hidden', !this.dropPanelHidden + '');
        } else {
            taBarDom.removeAttribute('hidden');
        }
        this.content.resize();
    }

    /**
     * 打开开奖历史面板
     */
    toggleOpenRecordPanel() {
        this.openRecordPanelShow = !this.openRecordPanelShow;
        if (LotteryPage.isSMorTD) {
            this.getWinOpenNumberSM();
        } else {
            this.getWinOpenNumber();
        }
    }

    /**
     * setTotal()
     *
     * set total money for SM
     *
     * @param (number) total
     *
     */
    setTotal(total) {
        this.totalMoney = total;
        this.changeTotalMoneySM();
    }

    /**
     * betInfoChanged()
     *
     *
     * @param (number) betInfo
     *
     */
    setBetInfo(data) {
        // console.log('data lottery.ts',data);

        let noArr = [];
        let betInfo = [];
        let code = '';
        // set data for betHistory
        this.betHistory = data;
        data.forEach((item) => {
            if (Number.isInteger(item.bets[0])) {
                noArr.push(item.amount + '#' + item.bets[0]);
            } else {
                betInfo.push({
                    code: item.bets[0],
                    amount: item.amount,
                });
            }
        });
        if (this.lotteryMathSM.gameType === 'SM01') {
            code = 'YMZT';
        } else if (this.lotteryMathSM.gameType === 'SM04') {
            code = 'YMBDW';
        }
        if (noArr.length >= 1) {
            betInfo.push({
                code: code,
                amount: noArr,
            });
        }
        //set data for bet() api
        this.betInfoSM = betInfo;
    }

    onTotal(totalParams) {
        this.content.resize();
        if (this.betTimes <= 0) {
            this.betTimes = 1;
        }
        this.totalNumber = totalParams.total;
        this.betType = totalParams.type;
        this.selectNo = totalParams.selectNo;
        this.defaultPosition = totalParams.defaultPosition;
        this.isPopupTriggered = true;
        this.changeTotalMoney();
    }

    /**
     * 监听投注倍数改变
     */
    changeBetTimes(val: any) {
        let maxMultiNumber = 1000000;
        if (val !== '' && val !== null && !isNaN(val) && val >= 0) {
            if (val > maxMultiNumber) {
                setTimeout(() => {
                    this.betTimes = maxMultiNumber;
                    this.changeTotalMoney();
                }, 0);
            } else if (val === 0) {
                setTimeout(() => {
                    this.betTimes = Math.floor(1);
                    this.changeTotalMoney();
                }, 0);
            } else {
                setTimeout(() => {
                    this.betTimes = Math.floor(val);
                    this.changeTotalMoney();
                }, 0);
            }
        } else if (val < 0) {
            setTimeout(() => {
                this.betTimes = 1;
                this.changeTotalMoney();
            }, 0);
        }
    }

    /**
     * changeTotalMoneySM
     *
     * calculate money
     *
     * @param
     * @return
     */
    changeTotalMoneySM() {
        this.totalMoney = Number(this.totalMoney.toFixed(2));
        this.enableBalance = this.balance - this.totalMoney;
        if (this.totalMoney > this.balance) {
            AppDialog.toast({
                toastCtrl: this.toastCtrl,
                message: '当前余额不足,请重新投注',
            });
        }
    }

    changeTotalMoney() {
        this.content.resize();
        this.totalMoney = Math.round(this.betTimes * this.totalNumber * this.payPrizeNum * 1000) / 1000;
        this.updateDyprize();
        this.enableBalance = this.common.numberWithCommas(this.balance - this.totalMoney);
        if (this.totalMoney > this.balance) {
            AppDialog.toast({
                toastCtrl: this.toastCtrl,
                message: 'Số dư hiện tại không đủ',
            });
        }
    }

    setBetSM() {
        console.log('setBetSM');

        let desc: string;
        let noStr: string = this.noShowStr;
        //数字选择
        let desTitle = this.planeTitle.replace('-', '_');
        desc = '[' + desTitle + '] ' + noStr;
        //投注确认对话框显示参数
        this.betDialogParams = {
            desTitle: desTitle,
            betNum: noStr,
        };
        this.betPost = {
            flag: 'bet',
            lotteryid: LotteryPage.lotteryId,
            total_money: this.totalMoney,
            trace_if: 0,
            total_nums: 1,
            issue_start: this.issue,
            'buyitem[]': "{'money':'" + this.totalMoney + "','nums':1,'times':'1'}",
        };
        this.addGoIssuseSM(this.betPost);
        this.betInfoSM.map((element) => {
            let betCode: any;
            betCode = 'betdata[' + element.code + ']';
            this.betPost[betCode] = element.amount;
        });
        //set message dialog sm
        this.messageDialogSM();
        // console.log('Bet post: ', this.betPost);
    }

    /**
     * Set message dialog sm
     */
    messageDialogSM() {
        let msgDialogSM: string = '';
        let msgNumber: string = '';
        if (this.lotteryMathSM.gameType === 'SM01') {
            msgNumber = '【一码中特】';
        } else if (this.lotteryMathSM.gameType === 'SM04') {
            msgNumber = '【一码不定位】';
        }
        this.betHistory.map((element) => {
            switch (element.bets[0]) {
                case 'SB_H':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码色波红】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'SB_LV':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码色波绿】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'SB_L':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码色波蓝】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'SX_S':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码生肖鼠】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'SX_N':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码生肖牛】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'SX_HU':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码生肖虎】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'SX_T':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码生肖兔】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'SX_L':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码生肖龙】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'SX_SHE':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码生肖蛇】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'SX_MA':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码生肖马】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'SX_Y':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码生肖羊】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'SX_H':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码生肖猴】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'SX_J':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码生肖鸡】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'SX_G':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码生肖狗】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'SX_Z':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码生肖猪】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'TMX':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码小】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'TMD':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码大】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'TMDAN':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码单】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'TMS':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码双】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'WSD':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码尾数大】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'WSX':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码尾数小】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'WSDAN':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码尾数单】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'WSS':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码尾数双】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'ZYMD':
                    msgDialogSM +=
                        "<tr><td class='code'>【正一码大】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'ZYMX':
                    msgDialogSM +=
                        "<tr><td class='code'>【正一码小】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'ZYMDAN':
                    msgDialogSM +=
                        "<tr><td class='code'>【正一码单】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'ZYMS':
                    msgDialogSM +=
                        "<tr><td class='code'>【正一码双】投注</td><td><span> : " + element.amount.toString() + '</span>元</td></tr>';
                    break;
                case 'TMWS_0':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码尾数" +
                        element.bets[0].slice(-1) +
                        '】投注</td><td><span> : ' +
                        element.amount.toString() +
                        '</span>元</td></tr>';
                    break;
                case 'TMWS_1':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码尾数" +
                        element.bets[0].slice(-1) +
                        '】投注</td><td><span> : ' +
                        element.amount.toString() +
                        '</span>元</td></tr>';
                    break;
                case 'TMWS_2':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码尾数" +
                        element.bets[0].slice(-1) +
                        '】投注</td><td><span> : ' +
                        element.amount.toString() +
                        '</span>元</td></tr>';
                    break;
                case 'TMWS_3':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码尾数" +
                        element.bets[0].slice(-1) +
                        '】投注</td><td><span> : ' +
                        element.amount.toString() +
                        '</span>元</td></tr>';
                    break;
                case 'TMWS_4':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码尾数" +
                        element.bets[0].slice(-1) +
                        '】投注</td><td><span> : ' +
                        element.amount.toString() +
                        '</span>元</td></tr>';
                    break;
                case 'TMWS_5':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码尾数" +
                        element.bets[0].slice(-1) +
                        '】投注</td><td><span> : ' +
                        element.amount.toString() +
                        '</span>元</td></tr>';
                    break;
                case 'TMWS_6':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码尾数" +
                        element.bets[0].slice(-1) +
                        '】投注</td><td><span> : ' +
                        element.amount.toString() +
                        '</span>元</td></tr>';
                    break;
                case 'TMWS_7':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码尾数" +
                        element.bets[0].slice(-1) +
                        '】投注</td><td><span> : ' +
                        element.amount.toString() +
                        '</span>元</td></tr>';
                    break;
                case 'TMWS_8':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码尾数" +
                        element.bets[0].slice(-1) +
                        '】投注</td><td><span> : ' +
                        element.amount.toString() +
                        '</span>元</td></tr>';
                    break;
                case 'TMWS_9':
                    msgDialogSM +=
                        "<tr><td class='code'>【特码尾数" +
                        element.bets[0].slice(-1) +
                        '】投注</td><td><span> : ' +
                        element.amount.toString() +
                        '</span>元</td></tr>';
                    break;
                default:
                    msgDialogSM +=
                        '<tr><td>' +
                        msgNumber +
                        '投注</td><td><span> : ' +
                        element.bets[0].toString() +
                        '号，' +
                        element.amount.toString() +
                        '</span>元</td></tr>';
            }
        });
        return msgDialogSM;
    }

    //服务器提交表单组合参数
    setBet() {
        if (this.totalNumber == 0) {
            this.betPost = null;
        } else {
            let betInfo: any;
            let desc: string;
            let codes: any = [];
            let descAr2: any = [];
            let point: number;
            let noStr: string = this.noShowStr;
            let noShow: string = '';
            //数字选择
            if (this.betType == 'digital') {
                this.selectNo.forEach((item) => {
                    codes.push(item.join('&'));
                    if (this.selectNo.length > 1) {
                        if (item.toString().length >= 2) {
                            descAr2.push(item.join(' '));
                        } else {
                            descAr2.push(item.join(''));
                        }
                    } else {
                        descAr2.push(item.join(','));
                    }
                });
                codes = noShow = codes.join('|');
                noShow = noShow.replace(/&/g, ',');
                noStr = descAr2.join('|').replace(/\s/g, ',');
                //point = this.dyprizeHide ? 1 : this.dyprize[this.dyprizeVal]['point'];
                point = this.dyprizeHide ? 1 : this.dyprize.point;
            }
            //单数字
            if (this.betType == 'digitalts') {
                codes = this.selectNo.join('&');
                noStr = this.selectNo.join('|');
            }
            //文本输入框
            if (this.betType == 'input') {
                codes = this.selectNo.join(';');
                noStr = noShow = this.selectNo.join('|');
            }
            // type: f-digital
            if (this.betType === 'f-digital') {

                if (!this.selectNo[0].hasOwnProperty('codePlay')) {
                    codes = this.selectNo.join(',');
                    noStr = noShow = this.selectNo.join('|');
                } else {
                    codes = this.selectNo[0].codePlay;
                    console.log('codes', codes);
                    noStr = noShow = this.selectNo[0].codePlay;
                    this.methodIdInDB = this.selectNo[0].methodid
                }

            }


            // if (this.betType === 'f-debotop') {
            //     this.betType = 'f-digital'



            //     // betInfo =  this.selectNo[0];
            // }

            if (noStr.length > 35) {
                noStr = noStr.substr(0, 34) + '...';
            }
            if (noShow.length > 35) {
                noShow = noShow.substr(0, 34) + '...';
            }
            noShow = noShow.replace(/[|]/g, '<span class="lineSepa"></span>');
            let desTitle = this.planeTitle.replace('-', '_');
            desc = '[' + desTitle + '] ' + noStr;
            //投注确认对话框显示参数
            this.betDialogParams = {
                desTitle: desTitle,
                betNum: noStr,
                betNumShow: noShow,
            };
            betInfo = {
                type: this.betType,
                methodid: this.methodIdInDB,
                zip: 0,
                nums: this.totalNumber,
                times: this.betTimes, //倍数
                money: this.totalMoney,
                mode: 1,
                point: point, //返点
                curtimes: new Date().getTime(),
                desc: desc, //描述
                codes: codes,
            };
            //任选添加参数
            if (this.defaultPosition.length > 0) {
                let positionNum = [];
                this.defaultPosition.forEach((item) => {
                    positionNum.push(item['type']);
                });
                betInfo['position'] = positionNum.join('&');
            }
            this.betPost = {
                lotteryid: LotteryPage.lotteryId,
                flag: 'save',
                lt_sel_times: 1, //返点模式
                lt_sel_modes: 1, //元角分模式
                lt_issue_start: this.isMMC ? 1 : this.issue, //开始期号
                lt_total_nums: this.totalNumber, //总注数
                lt_project: [JSON.stringify(betInfo)],
                lt_total_money: this.totalMoney,
            };
            // console.log('this.betPost ',this.betPost );


            // console.log('this.selectNo', this.selectNo);



            this.addGoIssuse(this.betPost);
            if (!this.dyprizeHide) {
                //this.betPost["lt_sel_dyprize"] = this.dyprize[this.dyprizeVal]['prize'] + "|" + this.dyprize[this.dyprizeVal]['point'];
                this.betPost['lt_sel_dyprize'] = this.dyprize.prize + '|' + this.dyprize.point;
            }
        }
    }

    /*
     * Add go issues sm
     */
    addGoIssuseSM(betPost: any) {
        let issues = this.goIssues;
        // console.log('issues', issues);
        if (issues.isGo) {
            let trace_issues = [];
            betPost['trace_count_input'] = issues.traceIssues.size;
            betPost['trace_total_money'] = issues.totalMoney;
            if (Array.isArray(issues.traceIssues)) {
                issues.traceIssues.forEach((item) => {
                    trace_issues.push(
                        JSON.stringify({
                            issue: item['issue'],
                            times: item['num'],
                        })
                    );
                });
            }
            betPost['buytrace'] = trace_issues;
            betPost['trace_if'] = 1;
            betPost['trace_stop'] = issues.goStop ? 'yes' : 'no';
        }

        this.betPost = betPost;
    }

    /**
     * 添加追号参数
     */
    addGoIssuse(betPost: any) {
        let issues = this.goIssues;
        if (issues.isGo) {
            if (this.isMMC) {
                betPost['lt_issue_start'] = issues.totalNum;
            } else {
                let lt_trace_issues = [];
                betPost['lt_trace_times_margin'] = 1;
                betPost['lt_trace_margin'] = 50;
                betPost['lt_trace_times_same'] = 1;
                betPost['lt_trace_diff'] = 1;
                betPost['lt_trace_times_diff'] = 1;
                betPost['lt_trace_count_input'] = issues.traceIssues.size;
                betPost['lt_trace_stop'] = 'yes';
                betPost['lt_trace_money'] = issues.totalMoney;
                issues.traceIssues.forEach((item) => {
                    lt_trace_issues.push(item['issue']);
                    betPost['lt_trace_times_' + item['issue']] = item['num'];
                });
                betPost['lt_trace_issues'] = lt_trace_issues;
                betPost['lt_trace_if'] = 'yes';
                betPost['lt_trace_stop'] = issues.goStop ? 'yes' : 'no';
            }
        }

        this.betPost = betPost;
    }

    ngAfterViewInit() {
        //let taBarDom = this.navCtrl.parent.elementRef.nativeElement.querySelector('ion-tabbar');
        let taBarDom = this.navCtrl.parent._elementRef.nativeElement.querySelector('div.tabbar');
        let addDom = document.createElement('div');
        addDom.setAttribute('tappable', '');
        addDom.className = 'submit';
        addDom.innerText = this.translate.instant('PLAC_A_BET');
        addDom.id = 'lottery-submit';
        taBarDom.appendChild(addDom);
        addDom.addEventListener('click', () => {
            if (LotteryPage.isSMorTD) {
                this.processBetSM();
            } else {
                this.processBet();
            }
        });
    }

    /**
     * processBetSM()
     *
     * Process when click button 确定投注
     *
     * @param
     * @return
     */
    processBetSM() {
        if (this.totalMoney > 0) {
            this.setBetSM();
            this.betDialogSM();
        } else {
            AppDialog.toast({
                toastCtrl: this.toastCtrl,
                message: this.translate.instant('INVALID_SELECTION'),
            });
        }
    }

    /**
     * processBet()
     *
     * Process when click button 确定投注
     *
     * @param
     * * @return
     */
    processBet() {
        if (this.goIssues.isGo && this.goIssues.traceIssues.size == 0) {
            AppDialog.toast({
                toastCtrl: this.toastCtrl,
                message: this.translate.instant('PLEASE_SELECT_DRAW'),
            });
            return;
        }
        if (this.betTimes <= 0) {
            this.betTimes = 1;
            this.changeTotalMoney();
        }
        if (this.totalNumber > 0) {
            this.setBet();
            this.betDialog();
        } else {
            if (Array.isArray(this.selectNo)) {
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: this.translate.instant('INVALID_SELECTION'),
                });
            } else {
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: this.translate.instant('INVALID_INPUT'),
                });
            }
        }
    }

    /**
     * 投注弹出对话框
     */
    betDialog() {
        let totalText: any;
        let totalNum: number;
        let issueTitle: string;
        let title: string;
        if (this.goIssues.isGo) {
            issueTitle = this.goIssues.totalNum;
            totalText = this.goIssues.totalMoney;
            totalNum = this.totalNumber * this.goIssues.totalNum;
            title = this.translate.instant('CONFIRM_NUOI',{issueTitle: issueTitle});
        } else {
            issueTitle = this.issue ? this.issue : '';
            title = this.translate.instant('CONFIRM_ISSUE',{issueTitle: issueTitle}) ;
            totalNum = this.totalNumber;
            totalText = this.totalMoney;
        }

        //this.pageDom.querySelector('#lx__iput').value = this.selectNo.join(';');
        let alertCmp = this.alertCtrl.create({
            title: title,
            cssClass: 'bet-dialog',
            message:
                '<div class="bet-info">' +
                '<div class="item-1 desTitle">' +
                this.betDialogParams.desTitle +
                '</div>' +
                '<div class="item-1">' +
                this.betDialogParams.betNumShow +
                '</div>' +
                '</div>' +
                '<div class="bet-num">' +
                '<table>' +
                '<tr><td>' + this.translate.instant('TOTAL_BET') + ':</td><td><span>' +
                totalNum +
                '</span>' + this.translate.instant('NUMBERS') + '</td></tr>' +
                '<tr><td>' + this.translate.instant('TOTAL_MONEY') + ':</td><td><span>' +
                this.common.numberWithCommas(+totalText) +
                '</span></td></tr>' +
                '</table>' +
                '</div>',
            buttons: [
                { text: this.translate.instant('CANCEL') },
                {
                    text: this.translate.instant('CONFIRM'),
                    handler: (data) => {
                        this.betService(alertCmp);
                        return true;
                    },
                },
            ],
        });
        alertCmp.present();
    }

    /**
     * betDialogSM()
     *
     */
    betDialogSM() {
        let issueTitle: string;
        let title: string;
        if (this.goIssues.isGo) {
            issueTitle = this.goIssues.totalNum;
            title = this.translate.instant('CONFIRM_NUOI') + ' ' + issueTitle + ' ?';
        } else {
            issueTitle = this.issue ? this.issue + '期' : '';
            title = this.translate.instant('CONFIRM_ISSUE') + ' ' + issueTitle + ' ?';
        }

        let alertCmp = this.alertCtrl.create({
            title: title,
            cssClass: 'bet-dialog',
            message:
                '<div class="bet-info-sm">' + this.translate.instant('SELECT_NUMBER_DETAIL') + '</div>' +
                '<div class="bet-num">' +
                '<table>' +
                this.messageDialogSM() +
                '</table>' +
                '</div>',
            buttons: [
                {
                    text: this.translate.instant('CANCEL'),
                },
                {
                    text: this.translate.instant('CONFIRM'),
                    handler: (data) => {
                        this.betServiceSM(alertCmp);
                        return true;
                    },
                },
            ],
        });
        alertCmp.present();
    }

    /**
     * bet SM
     * @param alertCmp
     */
    betServiceSM(alertCmp: any) {
        this.sixMarkService.lotteryBetSM(this.betPost, this).then((response) => {
            // console.log('Data after click bet: ', response);
            if (response['status'] == 'success' && response['data']['status'] == 'success') {
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: this.translate.instant('BET_SUCCESS'),
                    fn: () => {
                        if (!this.goIssues.isgo) {
                            // Clear betting history
                            this.lotteryMathSM.clearBetHistory();
                            // set enableBalance
                            this.enableBalance = response['data']['data'];
                            // set balance
                            this.balance = response['data']['data'];
                            this.content.resize();
                        } else {
                            this.events.publish('issues:goOver');
                        }
                    },
                });
            } else {
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: response['data']['data'],
                });
            }
        });
    }

    betService(alertCmp: any) {
        this.checkMB_DeDacBiet_3CangDacBiet((arrCode) => {
            // console.log('arrCode', arrCode);

            let arrGroupDualNumOld = [];
            let arrGroupDualNumLast = [];
            arrCode.forEach((itemCode) => {
                const codes = itemCode['codes'];
                const getMultiple = itemCode['multiple'];
                const getIssue = itemCode['issue'];
                const getMethodID = itemCode['methodid'];
                const getDualNums = this.createGroupDualNum(codes);
                getDualNums.forEach((dualNum) => {
                    arrGroupDualNumOld.push({ number: dualNum, multiple: getMultiple, issue: getIssue, methodID: Number(getMethodID) });
                });
            });
            const listBetSubmit = this.betPost['lt_project'];
            listBetSubmit.forEach((itemBetSub) => {
                const getTicketCur = JSON.parse(itemBetSub);
                if (this.flagCheckDualNumLottery(this.gameId, getTicketCur['methodid'])) {
                    let getMultiple = getTicketCur['times'];
                    const codes = getTicketCur['codes'];
                    const getMethodID = getTicketCur['methodid'];
                    const getDualNums = this.createGroupDualNum(codes);
                    getDualNums.forEach((dualNum) => {
                        arrGroupDualNumLast.push({
                            number: dualNum,
                            multiple: getMultiple,
                            issue: this.issue,
                            methodID: Number(getMethodID),
                        });
                    });
                }
            });
            if (this.goIssues.isGo) {
                const issues = this.goIssues;
                let arrTempLast = [];
                if (Array.isArray(issues.traceIssues)) {
                    issues.traceIssues.forEach((item) => {
                        arrGroupDualNumLast.forEach((itemDualNum) => {
                            arrTempLast.push({
                                number: itemDualNum['number'],
                                multiple: item['num'] * itemDualNum['multiple'],
                                issue: item['issue'],
                                methodID: Number(itemDualNum['methodID']),
                            });
                        });
                    });
                }
                arrGroupDualNumLast = arrTempLast;
            }

            const groupMultiOld = this.groupMultipleDualNum(arrGroupDualNumOld);
            const groupMultiLast = this.groupMultipleDualNum(arrGroupDualNumLast);
            const arrTempMulti = this.groupMultipleDualNum([...groupMultiOld, ...groupMultiLast]);

            var getMultiDB = arrTempMulti.filter(function (itemMulti) {
                return itemMulti['methodID'] === 6 || itemMulti['methodID'] === 1000;
            });
            var getMaxMultiDB = 0;
            if (getMultiDB.length > 0)
                getMaxMultiDB = Math.max.apply(
                    Math,
                    getMultiDB.map(function (o) {
                        return o.multiple;
                    })
                );

            var getMulti3Cang = arrTempMulti.filter(function (itemMulti) {
                return itemMulti['methodID'] === 21;
            });
            var getMaxMulti3Cang = 0;
            if (getMulti3Cang.length > 0)
                getMaxMulti3Cang = Math.max.apply(
                    Math,
                    getMulti3Cang.map(function (o) {
                        return o.multiple;
                    })
                );

            var getMulti4CangDB = arrTempMulti.filter(function (itemMulti) {
                return itemMulti['methodID'] === 23;
            });
            var getMaxMulti4CangDB = 0;
            if (getMulti4CangDB.length > 0)
                getMaxMulti4CangDB = Math.max.apply(
                    Math,
                    getMulti4CangDB.map(function (o) {
                        return o.multiple;
                    })
                );

            if (getMaxMultiDB > 2000 || getMaxMulti3Cang > 200 || getMaxMulti4CangDB > 20) {
                // 2000 là số tối đa cho đánh số kép bằng cho mỗi số
                arrTempMulti.sort((a, b) => b['multiple'] - a['multiple']); // sort z-a
                let str = '<ul>';
                arrTempMulti.forEach((item) => {
                    let clsRed = '';
                    if (
                        (item['multiple'] > 2000 && (item['methodID'] === 6 || item['methodID'] === 1000)) ||
                        (item['multiple'] > 200 && item['methodID'] === 21) ||
                        (item['multiple'] > 20 && item['methodID'] === 23)
                    ) {
                        clsRed = 'color-red invalid';
                    }
                    let pointFirst = 0;
                    let pointLast = 0;
                    let findExistOld = groupMultiOld.find(
                        (dualNumOld) => dualNumOld['number'] === item['number'] && dualNumOld['issue'] === item['issue']
                    );
                    let findExistLast = groupMultiLast.find(
                        (dualNumLast) => dualNumLast['number'] === item['number'] && dualNumLast['issue'] === item['issue']
                    );
                    if (findExistOld) {
                        pointFirst = findExistOld['multiple'];
                    }
                    if (findExistLast) {
                        pointLast = findExistLast['multiple'];
                    }
                    let pointRecent = 0;
                    let maxDualNum = '';
                    if (item['methodID'] === 6 || item['methodID'] === 1000) {
                        pointRecent = 2000 - pointFirst;
                        maxDualNum = '2000';
                    } else if (item['methodID'] === 21) {
                        pointRecent = 200 - pointFirst;
                        maxDualNum = '200';
                    } else if (item['methodID'] === 23) {
                        pointRecent = 20 - pointFirst;
                        maxDualNum = '20';
                    }
                    str += `<li>
                    <div>
                        <p>${this.translate.instant('BET_PLACED')} <strong>${pointFirst}/${maxDualNum}</strong> ${this.translate.instant('POINTS')}</p>
                        <p>${this.translate.instant('MAX_ADDITIONAL_BET')} <strong>${pointRecent}</strong> ${this.translate.instant('POINTS')}</p>
                        <p>${this.translate.instant('CURRENT_BET')} <span class="color-red"><strong>${pointLast}</strong></span> ${this.translate.instant('POINTS')}</p>
                    </div>
                    <div class="${clsRed} numberBet">[${item['number']}]</div>
                    <div class="issue">${this.translate.instant('ISSUE')} ${item['issue']}</div>
                </li>`;
                });
                str += '</ul>';
                let alertCmp = this.alertCtrl.create({
                    title: this.translate.instant('NOTIFICATION'),
                    cssClass: 'checkDualNumber',
                    message: `${this.translate.instant('YOU_EXCEED_THE_ALLOWED_BET_POINTS_FOR_EACH_DOUBLE_NUMBER')} <span class="font-700">${this.translate.instant('EACH_DOUBLE_NUMBER')}</span> <i>(${this.translate.instant('DOUBLE_NUMBER_IS_NUMBERS_WITH_THE_SAME_LAST_TWO_DIGITS_EX_00_11_22_155_066_1699_1300_ETC')}. ${this.translate.instant('APPLY_ONLY_TO_THE_FOLLOWING_PRIZES')}:</i><ul class="applyDualNum"><li>${this.translate.instant('NORTH_BORDER_NORTH_BORDER_18H25')} - <span class="color-red font-700">2000</span> ${this.translate.instant('POINTS')}</li><li>${this.translate.instant('NORTH_BORDER_THREE_CANG')} - <span class="color-red font-700">200</span> ${this.translate.instant('POINTS')}</li><li>${this.translate.instant('NORTH_BORDER_FOUR_CANG')} - <span class="color-red font-700">20</span> ${this.translate.instant('POINTS')}</li></ul>${str}`,
                    enableBackdropDismiss: false,
                    buttons: [
                        {
                            text: this.translate.instant('OK'),
                            handler: (data) => {
                                return true;
                            },
                        },
                    ],
                });
                alertCmp.present();

            } else {
                // console.log('submitBetLottery 2',this.betPost);

                this.submitBetLottery();
            }
        });
    }

    submitBetLottery() {
        this.lotteryService.lotteryBet(this.betPost, this).then((data) => {
            if (!data['msg']) {
                //  alertCmp.dismiss().catch(() => {});
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: this.translate.instant('BET_SUCCESS'),
                    fn: () => {
                        this.arrTempSaveDualNum = [];
                        if (!this.goIssues.isGo) {
                            console.log();

                            this.selectAreaView.initView();
                            this.totalNumber = 0;
                            this.totalMoney = 0;
                            this.betTimes = 1;
                            this.content.resize();
                        } else {
                            this.events.publish('issues:goOver');
                        }
                        if (this.isMMC) {
                            this.getWinOpenNumber();
                            // show result number lottery
                            this.openAnimation({
                                nums: data['openwinlist'][0]['winnumber'].split(','),
                                issue: this.common.convertTimeZoneVN(new Date(), 'HH:mm:ss'), //this.datePIPE.transform(new Date(), 'HH:mm:ss')
                            });
                        }
                        setTimeout(() => {
                            this.lotteryService.getBalance((data) => {
                                this.balance = data['balance'];
                            });
                        }, 1000);
                    },
                });
            } else {
                //   alertCmp.dismiss().catch(() => {});
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: (data['msg'] == 'Call bet api timeout') ? this.translate.instant('BET_FAILED') : data['msg'],
                });
            }
        });
    }

    groupMultipleDualNum(arrDualNum) {
        let flag = true;
        let i = 0;
        let j = 1;
        let countDualNum = 0;
        let arrTempDualNum = [];

        if (arrDualNum.length <= 0) {
            return arrTempDualNum;
        }

        while (flag) {
            if (
                arrDualNum.length > 1 &&
                arrDualNum[i]['number'] === arrDualNum[j]['number'] &&
                arrDualNum[i]['issue'] === arrDualNum[j]['issue']
            ) {
                countDualNum += arrDualNum[j]['multiple'];
                arrDualNum.splice(j, 1);
                j -= 1;
            }
            j += 1;
            if (j >= arrDualNum.length) {
                countDualNum += arrDualNum[i]['multiple'];
                arrTempDualNum.push({
                    number: arrDualNum[i]['number'],
                    multiple: countDualNum,
                    issue: arrDualNum[i]['issue'],
                    methodID: arrDualNum[i]['methodID'],
                });
                arrDualNum.splice(i, 1);
                j = 1;
                countDualNum = 0;
                if (arrDualNum.length === 0) {
                    flag = false;
                }
            }
            if (arrDualNum.length === 1) {
                arrTempDualNum.push(arrDualNum[i]);
                flag = false;
            }
        }

        return arrTempDualNum;
    }

    checkMB_DeDacBiet_3CangDacBiet(funCallBack?: any) {
        let issueArr = [];
        if (this.goIssues.isGo) {
            const issues = this.goIssues;
            // console.log('issues', issues);

            //panto -start
            if (Array.isArray(issues.traceIssues)) {
                issues.traceIssues.forEach((item) => {
                    issueArr.push(`'${item['issue']}'`);
                });
            }
            issueArr.push(`'${this.issue}'`);
        } else {
            issueArr.push(`'${this.issue}'`);
        }
        const params = { id: this.gameId, issue: issueArr.join(',') };
        this.lotteryService.lotteryCheck_DeMBDacBiet(params, this).then((data) => {
            const arrHis = data['reslist'];
            const arrCode = arrHis.filter((item) => {
                if (this.flagCheckDualNumLottery(item['lotteryid'], item['methodid'])) {
                    return item;
                }
            });
            funCallBack && funCallBack(arrCode);
        });
    }

    /**
     * @param lotteryID = 200 || "200"
     * @param methodID = 6 || "6"
     * @returns {boolean}
     */
    flagCheckDualNumLottery(lotteryID, methodID) {
        let flag = false;
        if (
            (Number(lotteryID) === 200 || Number(lotteryID) === 201) &&
            (Number(methodID) === 6 || Number(methodID) === 21 || Number(methodID) === 1000 || Number(methodID) === 23)
        ) {
            flag = true;
        }
        return flag;
    }

    /**
     * @param codes = "5&3|5" || "55, 35"
     * @returns {any[55]}
     */
    createGroupDualNum(codes) {
        let strTempOutCome = [];
        if (codes.search(/[|]/g) >= 0) {
            let checkSymbol = codes.split('|');
            let arrTemp = [];
            checkSymbol.forEach(function (itemCheck) {
                arrTemp.push(itemCheck.split('&'));
            });
            strTempOutCome = this.getDualNumber(this.allPossibleCases(arrTemp));
        } else {
            strTempOutCome = this.getDualNumber(codes.split(','));
        }
        return strTempOutCome;
    }

    /**
     * check so co ton tai kep bang
     * @param arrNumber = ["00", "12", "11", "122", "455", "10", "14",...]
     * @returns {any["00", "11", "122", "455"]}
     */
    getDualNumber(arrNumber) {
        let amountCheck = [];
        arrNumber.forEach(function (number) {
            let strNum = number.toString().trim();
            let numberTwoDigits = strNum.substring(strNum.length - 2); // get last digit number
            let splitNum = numberTwoDigits.split('');
            let getFirstNum = splitNum[0];
            let countCheck = 0;
            for (let i = 1; i < splitNum.length; i++) {
                if (getFirstNum === splitNum[i]) {
                    countCheck += 1;
                }
            }

            if (countCheck + 1 === splitNum.length) {
                amountCheck.push(number);
            }
        });
        return amountCheck;
    }

    /**
     * @param arr = [["1", "3", "5"], ["8", "0"],...]
     * @returns {any} = ["18", "10", "38", "30", "58", "50"]
     */
    allPossibleCases(arr) {
        if (arr.length === 1) {
            return arr[0];
        } else {
            let result = [];
            let allCasesOfRest = this.allPossibleCases(arr.slice(1)); // recur with the rest of array
            for (let i = 0; i < allCasesOfRest.length; i++) {
                for (let j = 0; j < arr[0].length; j++) {
                    result.push(arr[0][j] + allCasesOfRest[i]);
                }
            }
            return result;
        }
    }

    ionViewWillLeave() {
        LotteryPage.betMoney = this.totalMoney;
        console.log('LotteryPage.betMoney', LotteryPage.betMoney);
        LotteryPage.betTraceTime = this.betTimes;
    }

    goRecordList() {
        let rootNav = this.app.getRootNav();
        if (RecordListPage.hasInit) {
            rootNav.pop();
        } else {
            rootNav.push(RecordListPage, {
                lotteryId: LotteryPage.lotteryId,
                lotteryName: this.lotteryName,
            });
        }
    }

    //设置开奖动画
    openAnimation(nums: any) {
        this.winNumber = nums;
    }

    /**
     * 打开帮助中心
     */
    toggleHelper() {
        this.openHelper = !this.openHelper;
    }

    /**
     * 获取开奖数字
     * @param issue
     */
    getOpenRecord(issue: string, requestNum: number) {
        requestNum++;
        if (requestNum > 5) {
            return;
        }
        let postData = {
            issue: issue,
            lotteryid: LotteryPage.lotteryId,
        };
        this.lotteryService.getOpenWinRecored(postData, this.alertCtrl).then((data) => {
            if (!data['msg']) {
                if (LotteryPage.isSMorTD) {
                    data['code'] = this.smWinNumberToArray(data['code']);
                }

                let issueNew = issue;
                if (!this.isXoSoNhanh) {
                    issueNew = this.datePIPE.transform(issueNew, 'dd/MM/yyyy'); //this.datePIPE.transform(issueNew, 'dd/MM/yyyy');
                }
                this.openAnimation({
                    nums: data['code'],
                    issue: issueNew,
                });
            } else {
                setTimeout(() => {
                    this.getOpenRecord(issue, requestNum);
                }, 2000);
            }

            setTimeout(() => {
                this.lotteryService.getBalance((data) => {
                    this.balance = data['balance'];
                });
            }, 1000);
        });
    }

    timerShowResult(opentime, servertime, callBackFun) {
        let pourTime: number = (+new Date(opentime.replace(/-/g, '/')) - +new Date(servertime.replace(/-/g, '/'))) / 1000;
        this.titleKqxs = this.translate.instant('DANG_MO_THUONG');
        clearInterval(this.coutTimeoutResult);
        this.coutTimeoutResult = setInterval(() => {
            pourTime--;
            if (pourTime >= 0) {
                let hour: any = parseInt((pourTime / 3600).toString());
                let minute: any = parseInt(((pourTime - hour * 3600) / 60).toString());
                let second: any = parseInt((pourTime % 60).toString());
                if (hour < 10) {
                    hour = '0' + hour;
                }
                if (minute < 10) {
                    minute = '0' + minute;
                }
                if (second < 10) {
                    second = '0' + second;
                }
                this.coutTimeResult = hour + ':' + minute + ':' + second;
            }
            if (pourTime === -1) {
                clearInterval(this.coutTimeoutResult);
                this.titleKqxs = 'Xem ngay';
                callBackFun();
            }
        }, 1000);
    }

    /**
     * convert win number of sm to array
     */
    smWinNumberToArray(data) {
        let numbers = [];
        // winnumber exp: "12|43|21|9|2|10&7"
        // special number -> 7
        // numbers array 1->6 => 12, 43, 21, 9, 2, 10
        let types = data.split('&');

        if (types.length === 2) {
            let specialNumber = Number.parseInt(types[1]);
            let normalNumbers = types[0].split('|');

            numbers.push(specialNumber);
            normalNumbers.forEach((number) => {
                numbers.push(Number.parseInt(number));
            });
        }
        return numbers;
    }

    ngOnDestroy() {
        clearInterval(this.coutTimeoutResult);
        clearInterval(LotteryPage.countTimer);
        LotteryPage.lotteryId = null;
        this.events.unsubscribe('issues:go');
        this.events.unsubscribe('issues:change');
        this.events.unsubscribe('issues:goOver');
        this.events.unsubscribe('issues:goPage');
    }

    //关闭弹出窗体
    dismiss() {
        clearInterval(LotteryPage.countTimer);
        this.viewCtrl.getNav().parent.parent.pop();
    }

    // Popup Events Implementation
    /**
     * Use to detect outside of popup clicked
     * @param event
     */
    onSMTDClicked(event) {
        if (this.isPopupTriggered) {
            // Reset flag
            this.isSMTDPopupHidden = false;

            // Show popup
            this.isPopupTriggered = false;
        } else {
            // User click outside of popup
            // Hide popup
            this.isSMTDPopupHidden = true;

            // Cancel current bets
            this.lotteryMathSM.cancelCurrentBets();
        }
    }

    /**
     * Trigger to show popup
     * @param params
     */
    onOptionSelected(params) {
        this.isPopupTriggered = true;
    }

    /**
     * Call to source to tell them which coin is selected
     * @param selectedCoin
     */
    onPopupCoinSelected(selectedCoin) {
        // Hide popup
        this.isSMTDPopupHidden = true;

        // Calculate current betting total
        this.lotteryMathSM.calculateCurrentBetTotal(selectedCoin);
    }

    /**
     * Simply close the popup
     */
    onPopupCloseClicked() {
        // Hide popup
        this.isSMTDPopupHidden = true;

        // Cancel current bets
        this.lotteryMathSM.cancelCurrentBets();
    }

    /**
     * Call to source to pop back the betting history
     */
    onPopupBackClicked() {
        // Hide popup
        this.isSMTDPopupHidden = true;
        // Remove the last betting history
        this.lotteryMathSM.popBackBetHistory();
    }

    /**
     * Call to source to clear the betting history
     */
    onPopupClearClicked() {
        // Hide popup
        this.isSMTDPopupHidden = true;

        // Clear betting history
        this.lotteryMathSM.clearBetHistory();
    }

    showTblResult(winNumber: any, issue) {
        let issueNew = issue;
        // if (!this.isXoSoNhanh) {
        //     issueNew = this.common.convertTimeZoneVN(new Date(issue), 'DD/MM/YYYY'); //this.datePIPE.transform(issueNew, 'dd/MM/yyyy');
        // }
        console.log('issueNew', issueNew);

        this.openAnimation({
            nums: winNumber.split(','),
            issue: issueNew,
        });
    }

    updateDyprize(val?: any) {
        //this.totalNumWin = Math.round(this.betTimes*this.dyprize[+this.dyprizeVal].prizeF)*1000;
        this.totalNumWin = this.betTimes * this.dyprize.prize * 1000;
    }

    checkMMCGame(lotteryID: number) {
        if (this.arrMMCGameID.indexOf(lotteryID) > -1) {
            this.isXoSoNhanh = true;
        }
    }

    typeGameSegment() {
        this.selectAreaView.initView();
        this.totalNumber = 0;
        this.totalMoney = 0;
        this.betTimes = 1;
        this.content.resize();
    }

    incrementQty() {
        this.betTimes += 1;
        this.changeBetTimes(this.betTimes);
    }

    decrementQty() {
        if (this.betTimes - 1 < 1) {
            this.betTimes = 1;
        }
        else {
            this.betTimes -= 1;
        }
        this.changeBetTimes(this.betTimes);
    }

    handleRedirectResult() {
        this.theInAppBrowser.create(`https://aseanresult.com/detail?id=${this.gameId}`, '_self', this.options);
    }
}



// WEBPACK FOOTER //
// ./src/pages/lottery/lottery.ts